import { InventoryController } from '../controller/InventoryController';
import { BaseWidgetWebComponent } from '../../widget/BaseWidgetWebComponent';

export class InventoryWebComponent extends BaseWidgetWebComponent {
  constructor() {
    super();
    this.initialSetup({
      controllerConstructor: InventoryController,
    });
  }
}
